var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconStrikethroughS48Line = function SvgIconStrikethroughS48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 22.3H10v3.4h14.67c2.55.7 4.69 1.6 4.69 4.15 0 2.55-2.2 4.34-5.23 4.34-3.21 0-5.4-1.92-5.53-4.8h-3.7c.11 5.25 3.72 8.62 9.27 8.62 5.55 0 8.93-3.23 8.93-8.22 0-1.63-.36-2.99-1.1-4.1h6v-3.4.01ZM19.84 20.05c-.59-.62-.87-1.37-.87-2.28 0-2.29 1.99-3.89 4.85-3.89 2.86 0 4.84 1.76 4.96 4.4h3.6c-.1-5.19-3.25-8.27-8.46-8.27-5.21 0-8.58 3.05-8.58 7.96 0 .74.08 1.42.23 2.08h4.28-.01Z",
    fill: "current"
  })));
};
export default SvgIconStrikethroughS48Line;